import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "種類",
    isNumber: true,
  },
];

export const DiseaseAnalysis = {
  label: "疾病分析(成人健檢)",
  key: "DiseaseAnalysis",
  path: "HealthCenterHealthCheckup/DiseaseAnalysis",
  api: "TCS_V_HCCS05",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.DiseaseAnalysis {...options} />
  ),
  isRaw: true,
  isGroup: true,
  isColSum: true,
  isRowSum: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
